import { ModalService } from './../../../../commons/services/modal.service';
import { Component, OnInit } from '@angular/core';
import { TranslatedTextKey } from '../../contants/translate-key.constants';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegisterUserForm } from '../../../../commons/form-validators/forms/user/registerUser.form';
import { FormValidatorService } from '../../../../commons/form-validators/validators/form-validator.service';
import { ROUTER_LOGIN } from '../../../../commons/constants/router/router.constant';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { UserGraphQLService } from '../../../../graphQL/services/user/userGraphQL.service';
import { omitDeep } from '@apollo/client/utilities';
import { environment } from 'src/environments/environment';
import e from 'express';
import { SharedFormValidationsService } from 'src/app/commons/services/sharedFormValidations.service';
import { take } from 'rxjs';
import { ProgreesBarService } from 'src/app/commons/services/progrees-bar.service';
import { StoreConfigurationService } from 'src/app/graphQL/services/store-configurations/store-configurations.service';
import { StoreFuncionalityCodesModel } from 'src/app/commons/models/storeFuncionalityCodes.model';
import { TranslateService } from '@ngx-translate/core';
import { SharedHelpersService } from 'src/app/commons/helpers/generic/shared-helpers.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  date1: Date | undefined;
  date2: Date | undefined;
  myForm: FormGroup;
  newUser!: any;
  typeUser: number = 1;
  visibleDialog: boolean = false;
  showInvoices: boolean = false;
  translatedTextKeyLogin = TranslatedTextKey;
  permissions!: any[];
  generalPermissions: any[] = [];
  cementoPermissions: any[] = [];
  concretoPermissions: any[] = [];
  codes: StoreFuncionalityCodesModel;
  GENERAL_MODULE: any = 5;
  funcionalities!: any[];
  states: { stateCountryId: number; name: string }[] = [];
  cities: { cityId: number; name: string; stateCountryId: number }[] = [];
  filteredCities: { cityId: number; name: string; stateCountryId: number }[] = [];
  stateFieldVisible: boolean = false;
  cityFieldVisible: boolean = false;
  stateFieldRequired: boolean = false;
  cityFieldRequired: boolean = false;
  loading: boolean = false;
  changeTypeUser(): void {
    this.typeUser = 2;
  }

  onStateChange(stateCountryId: number | null | undefined): void {
    const cityControl = this.myForm?.get('cityId');
    cityControl?.reset(null);

    if (stateCountryId === null || stateCountryId === undefined) {
      this.filteredCities = [];
      cityControl?.disable({ emitEvent: false });
      return;
    }

    this.filteredCities = this.cities.filter(
      (c) => c.stateCountryId === stateCountryId
    );
    cityControl?.enable({ emitEvent: false });
  }

  private populateStatesAndCities(storeConfig: any): void {
    this.states = (storeConfig?.stateCountries ?? []).map((s: any) => ({
      stateCountryId: s.stateCountryId,
      name: this._sharedHelperService.capitalizeFirstLetter(s.name.toLowerCase()),
    }));
    this.cities = (storeConfig?.cities ?? []).map((c: any) => ({
      cityId: c.cityId,
      name: this._sharedHelperService.capitalizeFirstLetter(c.name.toLowerCase()),
      stateCountryId: c.stateCountryId,
    }));
    this.filteredCities = [];
    console.log('States:', this.states);
    console.log('Cities:', this.cities);
  }

  private extractAfterEntity(message: string): string {
    if (!message) return '';
    const idx = message.toLowerCase().indexOf('entity');
    if (idx < 0) return message;
    return message.substring(idx + 'entity'.length).trim();
  }

  private applyDynamicFieldRules(
    fields: any[],
    fieldName: string,
    controlName: string
  ): { visible: boolean; required: boolean } {
    const field = fields?.find((f: any) => f.fieldName === fieldName);
    const control = this.myForm.get(controlName);

    if (!field) {
      return { visible: false, required: false };
    }

    if (field.isVisible === false) {
      control?.clearValidators();
      control?.setValue(null, { emitEvent: false });
      control?.updateValueAndValidity({ emitEvent: false });
      return { visible: false, required: false };
    }

    const required = field.isMandatory === true;
    if (required) {
      control?.setValidators([Validators.required]);
    } else {
      control?.clearValidators();
    }
    control?.updateValueAndValidity({ emitEvent: false });
    return { visible: true, required };
  }

  constructor(
    private fb: FormBuilder,
    private userDetailsFormService: RegisterUserForm,
    public fV: FormValidatorService,
    private router: Router,
    private messageService: MessageService,
    public _userService: UserGraphQLService,
    public modalService: ModalService,
    private primeNGConfig: PrimeNGConfig,
    private storeConfigurationsService: StoreConfigurationService,
    private progreesBarService: ProgreesBarService,
    public _sharedFormValidationsService: SharedFormValidationsService,
    private translate: TranslateService,
    private _sharedHelperService: SharedHelpersService,
  ) {

    this.codes = new StoreFuncionalityCodesModel();
    if (this._userService?.userInfo?.email) {
      this.myForm = this.userDetailsFormService.generateFormGroupFederated(
        this._userService.userInfo
      );
    } else {
      this.myForm = this.userDetailsFormService.generateFormGroup();
    }

    this.myForm.get('cityId')?.disable({ emitEvent: false });

    this.setReGenericFields();
  }

  setReGenericFields() {
    this._userService
      .getFormByModuleId(this.GENERAL_MODULE, environment.storeIdComplete)
      .subscribe({
        next: (data: any) => {
          const genericForm = data.fieldsByModuleId.find(
            (form: { formName: string }) => form.formName === 'GENERIC_FORM'
          );

          if (genericForm.fields.length > 0) {
            const stateRules = this.applyDynamicFieldRules(
              genericForm.fields,
              'State',
              'stateCountryId'
            );
            this.stateFieldVisible = stateRules.visible;
            this.stateFieldRequired = stateRules.required;

            const cityRules = this.applyDynamicFieldRules(
              genericForm.fields,
              'City',
              'cityId'
            );
            this.cityFieldVisible = cityRules.visible;
            this.cityFieldRequired = cityRules.required;

            if (!this.stateFieldVisible) {
              this.filteredCities = [];
              this.myForm.get('cityId')?.disable({ emitEvent: false });

              this.myForm.get('stateCountryId')?.disable({ emitEvent: false });
            }

            this._sharedFormValidationsService
              .getValidationsForForm(genericForm)
              .pipe(take(1))
              .subscribe(
                ({ formGroup, errorMessagesMap, fileNameLabelMap }) => {
                  if (formGroup.controls['Phone']) {
                    const control = this.myForm.controls['phoneNumber'];
                    const existingValidator = control.validator;
                    const newValidator = formGroup.controls['Phone']?.validator;

                    // Combine validators (if both exist)
                    if (newValidator) {
                      control.setValidators([
                        ...(existingValidator ? [existingValidator] : []),
                        newValidator,
                      ]);
                      control.updateValueAndValidity();
                    }
                  } else {
                  }
                },
                (error) => { }
              );
          }
        },
        error: (error: any) => { },
      });
  }

  ngOnInit() {
    this.myForm.get('termsAndConditions')?.valueChanges.subscribe((accepted: boolean) => {
      this.myForm.get('termsAcceptedDate')?.setValue(accepted ? new Date() : null);
      this.myForm.get('habeasData')?.setValue(accepted);
    });

    this.storeConfigurationsService.getStoreFunctionality(environment.storeId).subscribe(resp => {
      if (resp != null) {
        this.showInvoices = resp.funcionalitiesByStoreId.filter((item: any) => item.functionalityCode === this.codes.invoices).length > 0 ? true : false;
      }
    });

    if (!this._userService.storeConfig) {
      this.getStoreConfig();
    } else {
      this.permissions = this.mapPermissions(
        this._userService.storeConfig.permissionsDefaults
      );

      this.generalPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 0 || !p.flowsId);
      this.cementoPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 1);
      this.concretoPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 2);

      this._userService.storeConfig.permissionsDefaults
        .filter((x: { isRequired: boolean }) => x.isRequired == true)
        .forEach((permission: any) => {
          this.togglePermission(permission);
        });

      this.populateStatesAndCities(this._userService.storeConfig);
    }
  }

  mapPermissions(
    permissionsDefaults: {
      permissionId: string;
      action: string;
      description: string;
      isRequired: boolean;
      id: number;
    }[]
  ): any[] {
    return permissionsDefaults.map((permission) => ({
      id: permission.id,
      label: permission.description,
      checked: permission.isRequired,
    }));
  }

  getStoreConfig() {
    this._userService.getStoreConfig(environment.storeIdComplete).subscribe({
      next: (data: any) => {
        this._userService.storeConfig = data.getStoreInfo;

        this.permissions = this.mapPermissions(
          this._userService.storeConfig.permissionsDefaults
        );

        this.generalPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 0 || !p.flowsId);
        this.cementoPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 1);
        this.concretoPermissions = this._userService.storeConfig.permissionsDefaults.filter((p: any) => p.flowsId === 2);

        this.populateStatesAndCities(this._userService.storeConfig);

        this._userService.storeConfig.permissionsDefaults
          .filter((x: { isRequired: boolean }) => x.isRequired == true)
          .forEach((permission: any) => {
            this.togglePermission(permission);
          });
      },
    });
  }
  // Toggle permission selection
  togglePermission(permissionId: any) {
    const permissionsArray = this.myForm.get(
      'requestedPermissions'
    ) as FormArray;

    if (
      permissionsArray.controls.find(
        (control) => control.value.id === permissionId.id
      )
    ) {
      // If the permission is already selected, remove it
      const index = permissionsArray.controls.findIndex(
        (control) => control.value.id === permissionId.id
      );
      permissionsArray.removeAt(index);
    } else {
      // If the permission is not selected, add it
      permissionsArray.push(this.fb.control(permissionId));
    }
  }

  goBack() {
    this.router.navigate([ROUTER_LOGIN.CREATE_ACCOUNT.FORM]);
  }

  submitForm() {
    window.scrollTo(0, 0);
    console.log('Form Value:', this.myForm);
    if (this.myForm.valid) {
      this.newUser = {
        ...this.myForm.getRawValue(),
        habeasData: !!this.myForm.get('termsAndConditions')?.value,
        createdDate: new Date(),
        salesforceSync: false,
      };

      this.SaveUser();
    } else {
      // this.messageService.add({
      //   severity: 'warn',
      //   summary: '',
      //   detail: 'Faltan campos obligatorios por completar. Revisa el formulario antes de continuar.',
      // });

      this.modalService.toggleModal(
        this.translate.instant('transversales.notification').toString().toUpperCase(),
        this.translate.instant('mcfLoginShell.signup.missingRequiredFields').toString(),
        true,
        'info'
      );
      this.myForm.markAllAsTouched();
    }
  }
  removeTypename(data: any): any {
    // Remove __typename from each permission
    const cleanedPermissions = data.requestedPermissions.map((o: any) =>
      omitDeep(o, '__typename')
    );

    // Return the new object without __typename
    return {
      ...data,
      requestedPermissions: cleanedPermissions,
    };
  }
  private SaveUser() {
    this.progreesBarService.showProgressBar();
    this.loading = true;
    const sanitizedData = this.removeTypename(this.newUser);
    sanitizedData.sendToCrm = false;
    this._userService.createUser(sanitizedData).subscribe({
      next: (data: any) => {
        this.progreesBarService.hideProgressBar();
        this.modalService.toggleModal(
          this.translate.instant('transversales.notification').toString().toUpperCase(),
          this.translate.instant('mcfLoginShell.signup.registrationReceived').toString(),
          true,
          'info'
        );

        this.router.navigate([ROUTER_LOGIN.LOGIN.FORM]);
      },
      error: (error: any) => {
        this.loading = false;
        this.progreesBarService.hideProgressBar();
        if (error.networkError) {
          if (error.networkError.error && error.networkError.error.errors) {
            for (const err of error.networkError.error.errors) {
              switch (err.extensions.code) {
                case 'GN1003':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.emailAlreadyRegistered').toString(),
                    true,
                    'info'
                  );
                  break;

                case 'GN1004':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.fiscalIdNotFound').toString(),
                    true,
                    'info'
                  );
                  break;

                case 'EXT8002':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.extractAfterEntity(err.message),
                    true,
                    'info'
                  );
                  break;

                default:
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.registrationError').toString(),
                    true,
                    'info'
                  );
                  break;
              }
            }
          } else {
            this.modalService.toggleModal(
              this.translate.instant('transversales.error').toString().toUpperCase(),
              this.translate.instant('mcfLoginShell.signup.registrationError').toString(),
              true,
              'info'
            );
          }
        } else {

          if (error?.graphQLErrors?.length) {

            error.graphQLErrors.forEach((graphQLError: any) => {
              const { message, locations, path, extensions } = graphQLError;
              switch (extensions.code) {
                case 'GN1003':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.emailAlreadyRegistered').toString(),
                    true,
                    'info'
                  );
                  break;

                case 'GN1004':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.fiscalIdNotFound').toString(),
                    true,
                    'info'
                  );
                  break;

                case 'EXT8002':
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.extractAfterEntity(message),
                    true,
                    'info'
                  );
                  break;

                default:
                  this.modalService.toggleModal(
                    this.translate.instant('transversales.error').toString().toUpperCase(),
                    this.translate.instant('mcfLoginShell.signup.registrationError').toString(),
                    true,
                    'info'
                  );
                  break;
              }
            });
          }


        }
      },
    });
  }

  openTerms($event: any) {
    $event.preventDefault();
    this.modalService.toggleModal(
      this.translate.instant('mcfLoginShell.termsAndConditionsText').toString(),
      this._userService.storeConfig.termsAndConditions,
      true,
      this.translate.instant('transversales.error').toString().toUpperCase()
    );
  }
}
